import { of } from "rxjs";
import { catchError, filter, map, mergeMap } from "rxjs/operators";
import { StateObservable } from "redux-observable";
import { LOCATION_CHANGE } from "connected-react-router";

import { Effect } from "../../../../../../../../../redux/types/effect.type";
import { EffectActionsObservable } from "../../../../../../../../../redux/types/effect-actions-observable.type";
import { isActionType } from "../../../../../../../../../redux/action.functions";
import { RootState } from "../../../../../../../../../redux/store";

import * as FlyerDetailPageStore from "../../../store/flyer-detail-page.store";

import * as actions from "../store/flyer-detail-page-assets.actions";
import * as store from "../store/flyer-detail-page-assets.store";
import * as service from "../services/flyer-detail-page-assets.service";

import { FlyerDetailPageAssetsActions } from "./flyer-detail-page-assets.actions";

const fetchPageAssets: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(FlyerDetailPageAssetsActions.FetchPageAssets)),
    map((action) => action.payload),
    mergeMap((pageId) =>
      service.fetchAssets(pageId).pipe(
        map((assets) => actions.fetchPageAssetsSuccess(assets)),
        catchError((error) => of(actions.fetchPageAssetsFailure(error)))
      )
    )
  );

const fetchPageAssetsSuccess: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(FlyerDetailPageAssetsActions.FetchPageAssetsSuccess)),
    map((action) => action.payload),
    map(actions.setPageAssets)
  );

const reset: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter((action) => action.type === LOCATION_CHANGE),
    map(() => actions.resetPageAssets())
  );

const uploadPageAssets: Effect = (
  action$: EffectActionsObservable,
  state$: StateObservable<RootState>
) =>
  action$.pipe(
    filter(isActionType(FlyerDetailPageAssetsActions.UploadPageAssets)),
    map((action) => ({
      assets: action.payload,
      pageId: FlyerDetailPageStore.getPageId(state$.value),
    })),
    mergeMap(({ assets, pageId }) =>
      service.uploadAssets(assets, Number(pageId)).pipe(
        map((assets) => actions.uploadPageAssetsSuccess(assets)),
        catchError((error) => of(actions.uploadPageAssetsFailure(error)))
      )
    )
  );

const uploadPageAssetsSuccess: Effect = (
  action$: EffectActionsObservable,
  state$: StateObservable<RootState>
) =>
  action$.pipe(
    filter(isActionType(FlyerDetailPageAssetsActions.UploadPageAssetsSuccess)),
    map((action) => ({
      newAssets: action.payload,
      currentAssets: store.getPageAssets(state$.value),
    })),
    map(({ newAssets, currentAssets }) =>
      actions.setPageAssets(service.addAssetsToAssets(newAssets, currentAssets))
    )
  );

export const FlyerDetailPageAssetsEffects = [
  fetchPageAssets,
  fetchPageAssetsSuccess,

  uploadPageAssets,
  uploadPageAssetsSuccess,

  reset,
];
